import { clubbiStyled } from 'clubbi-ui'

export const StyledContainer = clubbiStyled('div')(({ theme }) => ({
  backgroundColor: theme.palette.brandGrey.light,
  width: '100vw',
  minHeight: '100vh',
  padding: '20px 15px',
  [theme.breakpoints.up('md')]: {
    padding: '20px 0',
  },
}))

export const StyledContent = clubbiStyled('div')(({ theme }) => ({
  maxWidth: '600px',
  margin: '10px auto',
  [theme.breakpoints.up('md')]: {
    margin: '20px auto',
    padding: 0,
  },
}))

export const StyledHeader = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
}))

export const StyledLogo = clubbiStyled('img')(({ theme }) => ({
  maxWidth: '150px',
  height: 'auto',
  alignSelf: 'flex-start',
  [theme.breakpoints.up('md')]: {
    maxWidth: '200px',
  },
}))

export const StyledTitle = clubbiStyled('h1')(({ theme }) => ({
  fontWeight: 800,
  fontSize: '30px',
  lineHeight: '30px',
  margin: 0,
  color: theme.palette.brandGrey[100],
  [theme.breakpoints.up('md')]: {
    fontSize: '40px',
    lineHeight: '40px',
  },
}))

export const StyledDescription = clubbiStyled('p')(({ theme }) => ({
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '20px',
  margin: 0,
}))

export const StyledLink = clubbiStyled('a')(({ theme }) => ({
  color: theme.palette.brandPurple.main,
  textDecoration: 'underline',
  '&:hover': {
    color: theme.palette.brandPurple.main,
  },
}))

export const StyledError = clubbiStyled('div')(({ theme }) => ({
  color: theme.palette.brandGrey[80],
  fontSize: '16px',
  padding: '15px 0',
}))
